
import {defineComponent, PropType} from "vue";

const __default__ = defineComponent({
  name: "ProgressBar",
  props: {
    filledPercentage: {
      type: Number
    },
    theme: {
      type: String as PropType<"light" | "dark">,
      default: "light"
    },
    width: {
      type: String,
      default: "100%"
    }
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "7a75af48": (_ctx.width)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__